import Base from "./base.service.js";
import Vue from "vue";
export default class Job extends Base {
    constructor() {
        super("job");
    }
    exportDataJob(name, params) {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path + name, { params })
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
}
